import { render, staticRenderFns } from "./registration-form.vue?vue&type=template&id=67479043&scoped=true"
import script from "./registration-form.vue?vue&type=script&lang=js"
export * from "./registration-form.vue?vue&type=script&lang=js"
import style0 from "./registration-form.vue?vue&type=style&index=0&id=67479043&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67479043",
  null
  
)

export default component.exports